const logos = require.context('../logos', true, /.svg$/);
/**
 * Get logo for payment method
 * @param {string} type Payment type. card/konbini/browser
 * @param {string} id id specific to payment type
 */
function getPaymentLogo(type, id) {
  return logos(`./${type}/${id}.svg`);
}

export default getPaymentLogo;
